import { isBefore, parseISO } from 'date-fns';

import { AwardType, Bonus } from '../../../../types/bonus';
import { GenericAttachment } from '../types/generic-attachment';
import { srcToAttachment } from '../utils/attachment';

export const isWithinEditWindow = (bonus: Pick<Bonus, 'editable_until'>): boolean => isBefore(new Date(), parseISO(bonus.editable_until));

interface BonusContents {
	images: GenericAttachment[];
	text: string;
}

// Matches text such as "![](https://www.example.com/image.jpg)""
const IMAGE_TAG_REGEX = /!\[\]\(([^)]+)\)/g;
export const parseContent = (bonus: Bonus): BonusContents => {
	return [...bonus.reason.matchAll(IMAGE_TAG_REGEX)].reduce<BonusContents>(
		({ images, text }, curr) => {
			return {
				images: images.concat(srcToAttachment(curr[1])),
				text: text.replace(curr[0], '').trim(),
			};
		},
		{ images: bonus.attachments, text: bonus.reason }
	);
};

export const getCelebrationType = (bonus: Bonus) => {
	switch (bonus.award_type) {
		case AwardType.WorkAnniversary:
			return 'work_anniversary';
		case AwardType.Birthday:
			return 'birthday';
		case AwardType.Welcome:
			return 'welcome';
		default:
			return '';
	}
};

export const isCelebration = (bonus: Bonus): boolean => {
	if (!bonus.award_type) return false;

	return [AwardType.WorkAnniversary, AwardType.Birthday, AwardType.Welcome].includes(bonus.award_type);
};

export const getRecognitionType = (bonus: Bonus) => {
	return bonus.award_type === null
		? 'peer_to_peer_recognition'
		: bonus.award_type === AwardType.Claimable
			? 'claimable_award'
			: bonus.award_type === AwardType.Award
				? 'manual_award'
				: 'automated_award';
};
